module.exports = __webpack_public_path__ + "static/media/p5.858b6a11.jpg";